import $ from "jquery";
import "arrive";
import "slick-carousel";

$(document).ready(function () {
    document.arrive('.block-profile-blocks-container', {existing: true}, function () {
        let $slider = $(this);
        $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrows: false,
            cssEase: "linear",
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: "unslick",
                }
            ],
        });
    });
});

function fixMobileSectionsFp() {
    let $p_blocks_sections = $('.block-profile-blocks');
    if ( $p_blocks_sections.length ) {
        if ($(window).width() < 1025) {
            let $p_blocks_contents = $('.block-profile-block-content-container');
            let last_section = $p_blocks_sections.hasClass('last');
            let id = $($p_blocks_sections[0]).attr('id').slice(0, -1);
            let init_last_section = last_section;
            let do_nothing = false;
            let html = '';

            if ($(window).width() < 992) {
                if ($(window).width() >= 768) {
                    // Tablet
                    $p_blocks_contents.each(function(index, el) {
                        if(index % 2 === 0) {
                            html += openSection(id+index);
                            let section_content = $('<div/>');
                            section_content.append($(el).clone());
                            init_last_section = false;
                            let $next = $($p_blocks_contents[index+1]);
                            if ($next.length) {
                                section_content.append($next.clone());
                                init_last_section = true;
                            }
                            html += section_content.html();
                            html += closeSection();
                        }
                    });
                } else {
                    // Phone
                    html += openSection(id+0);
                    $p_blocks_contents.each(function(index, el) {
                        let section_content = $('<div/>');
                        section_content.append($(el).clone());
                        html += section_content.html();
                    });
                    html += closeSection();
                    init_last_section = true;
                }
            } else {
                if ($(window).height() >= 800) {
                    // Tablet
                    let count = 0;
                    let skip = false;
                    $p_blocks_contents.each(function(index, el) {
                        if(!skip) {
                            if (count === 0) {
                                html += openSection(id + index);
                            }
                            let section_content = $('<div/>');
                            section_content.append($(el).clone());
                            init_last_section = false;
                            if ($(el).hasClass('col-lg-6')) {
                                count++;
                                let $next = $($p_blocks_contents[index + 1]);
                                if ($next.length) {
                                    section_content.append($next.clone());
                                    init_last_section = true;
                                    count++;
                                }
                                skip = true;
                            } else {
                                count += 2;
                            }
                            html += section_content.html();
                            if(count === 4) {
                                html += closeSection();
                                count = 0;
                            }
                        } else {
                            skip = false;
                        }
                    });
                    if(count > 0) {
                        html += closeSection();
                    }
                } else {
                    do_nothing = true;
                }
            }

            if(!do_nothing){
                let $insert_pos = $($p_blocks_sections[0]).prev('section');
                $p_blocks_sections.remove();
                $insert_pos.after($('<div/>').html(html).contents());
                // fix last section
                if (last_section) {
                    let $last = $('.block-profile-blocks').last();
                    $last.addClass('last');
                    if (!init_last_section) {
                        $last.removeClass('section fp-auto-height');
                    }
                }
            }
        }
    }
}

function openSection(id) {
    return '<section class="block-profile-blocks section fp-auto-height" id="'+id+'"><div class="block-profile-blocks-container srg-container-fullwidth row">';
}

function closeSection() {
    return '</div></section>';
}

export default {
    fixMobileSectionsFp
}
